import { useAuth0 } from '@auth0/auth0-react';
import { Button, Box, Typography } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: Props) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  if (isLoading) return null;

  if (!isAuthenticated) {
    return (
      <Box sx={{ textAlign: 'center', mt: 8 }}>
        <Typography variant='h6' sx={{ mb: 2 }}>Sign in to continue</Typography>
        <Button variant='contained' onClick={() => loginWithRedirect()}>Sign In</Button>
      </Box>
    );
  }

  return <>{children}</>;
}
